// import React, { useEffect, useState } from 'react';
// import { BASE_URL } from '../../api/apiClient';

// const TopBar = () => {
//   const [topbar, setTopbar] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     (async () => {
//       try {
//         const res = await fetch(`${BASE_URL}/api/femcare/?clinic=mukta`);
//         const json = await res.json().catch(() => ({}));
//         if (!res.ok) throw new Error(json?.error || `Request failed (${res.status})`);
//         setTopbar(json?.topbar ?? null);
//       } catch (e) {
//         setError(e.message);
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, []);

//   // Don't render anything while loading, on error, or if the section
//   // failed to load — same convention as Footer/Hero.
//   if (loading || error || !topbar) return null;

//   return (
//     <div className="primary-bg w-full">
//       <div className=" px-4 md:px-8">
//         <div className="flex items-center justify-between h-10">

//           {/* Left: Call + Office Hours */}
//           <div className="flex items-center gap-1 text-white ava-text-sm font-light">
//             <img
//               src="/Home/phone.svg"
//               alt="Phone"
//               className="w-3.5 h-3.5 mr-1 flex-shrink-0"
//             />
//             <span>
//               {topbar.contact?.label} : {topbar.contact?.phone}
//             </span>
//             <span className="mx-2 opacity-60">-</span>
//             <span className="hidden sm:inline">{topbar.contact?.officeHours}</span>
//           </div>

//           {/* Right: Experience App on Mobile */}
//           <div className="flex items-center gap-2 text-white ava-text-sm font-light">
//             <span className="hidden sm:inline">{topbar.appBanner?.label}</span>
//             <span className="sm:hidden">Get the App</span>

//             {/* Play Store */}
//             <a
//               href={topbar.appBanner?.playStoreLink}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="flex items-center hover:opacity-80 transition-opacity"
//               aria-label="Download on Google Play"
//             >
//               <img src="/Home/playstore.svg" alt="Google Play" className="h-5 w-5" />
//             </a>

//             {/* Apple Store */}
//             <a
//               href={topbar.appBanner?.appStoreLink}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="flex items-center hover:opacity-80 transition-opacity"
//               aria-label="Download on App Store"
//             >
//               <img src="/Home/applestore.svg" alt="App Store" className="h-5 w-5" />
//             </a>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default TopBar; 


// export default TopBar;
import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../../api/apiClient';

const ITEM_ICONS = {
  call: '/Home/phone.svg',
  phone: '/Home/phone.svg',
  email: '/Home/mailWhite.svg',
  location: '/Home/locationWhite.svg',
};

const SOCIAL_ICONS = {
  facebook: '/Home/facebook.svg',
  instagram: '/Home/insta.svg',
  youtube: '/Home/youtube.svg',
  twitter: '/Home/twitter.svg',
  linkedin: '/Home/linkedin.svg',
  location: '/Home/location.svg',
};

const isActive = (i) => i.status !== 0;
const byOrder = (arr) => [...arr].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

// Recognized "type" for an item/link: by label first (Call, Email, Location…),
// falling back to guessing from the value's shape for icon-only items with no label.
function detectType(entry) {
  const key = (entry.label || '').trim().toLowerCase();
  if (key === 'call' || key === 'phone') return 'phone';
  if (key === 'email') return 'email';
  if (key === 'location') return 'location';
  if (key === 'facebook') return 'facebook';
  if (key === 'instagram') return 'instagram';
  if (key === 'youtube') return 'youtube';
  if (key) return null; // labeled but unrecognized (e.g. "Office hours") — no icon, no auto-link

  const v = entry.value || '';
  if (v.includes('@')) return 'email';
  if (/^[+\d]/.test(v)) return 'phone';
  return 'location';
}

function iconForItem(item) {
  const type = detectType(item);
  return type ? ITEM_ICONS[type] : undefined;
}

function iconForLink(link) {
  const type = detectType(link);
  return type ? SOCIAL_ICONS[type] : undefined;
}

// Builds a clickable href for a left-side item: explicit item.href wins,
// otherwise derive tel:/mailto:/maps-search from the detected type.
function hrefForItem(item) {
  if (item.href) return item.href;
  const type = detectType(item);
  if (type === 'phone') return `tel:${item.value.replace(/[^+\d]/g, '')}`;
  if (type === 'email') return `mailto:${item.value}`;
  if (type === 'location') return `https://maps.google.com/?q=${encodeURIComponent(item.value)}`;
  return null; // e.g. "Office hours" — not a link
}

const TopBar = () => {
  const [topbar, setTopbar] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/femcare/?clinic=mukta`);
        const json = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(json?.error || `Request failed (${res.status})`);
        setTopbar(json?.topbar ?? null);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading || error || !topbar) return null;

  const items = byOrder(topbar.items || []).filter(isActive);
  const rightSlot = topbar.rightSlot;
  const mode = rightSlot?.mode ?? 'appBanner';
  const socialLinks = byOrder(rightSlot?.socialLinks || []).filter(isActive);
  const bgClass = topbar?.theme?.backgroundColor || 'primary-bg';
  const textColor = topbar?.theme?.textColor || 'text-white';
  return (
    <div className={` w-full`} style={{backgroundColor:bgClass}}>
      <div className="px-4 md:px-8">
        <div className="flex items-center justify-between h-10">

          {/* Left: items — each renders as a link when we can build one (tel/mailto/maps),
              plain text otherwise (e.g. Office hours). Label shown only if provided. */}
          <div className="flex items-center gap-6  text-white  flex-wrap">
            {items.map((item, idx) => {
              const icon = iconForItem(item);
              const href = hrefForItem(item);
              const content = (
                <span className="flex items-center gap-1 ava-text-sm cursor-pointer" style={{ color: textColor }}>
                  {icon && <img src={icon} alt={item.label || 'icon'} className="w-4 h-4 flex-shrink-0" />}
                  <span className={idx === 0 ? '  ava-text-sm' : ' hidden sm:inline  ava-text-sm'} style={{ color: textColor }}>
                    {item.label ? `${item.label} : ${item.value}` : item.value}
                  </span>
                </span>
              );
              return (
                <React.Fragment key={item.id}>
                  {idx > 0 && !href && <span className="opacity-60">-</span>}
                  {href ? (
                    
                  <a    href={href}
                      target={href.startsWith('http') ? '_blank' : undefined}
                      rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
                      className="flex items-center cursor-pointer"
                    >
                      {content}
                    </a>
                  ) : (
                    content
                  )}
                </React.Fragment>
              );
            })}
          </div>

          {/* Right: app banner (flat icons) or social links (circular white chips) */}
          <div className="flex items-center gap-2 text-white ">
            {/*  ava-text-sm */}
            {mode === 'appBanner' ? (
              <>
                <span className="hidden sm:inline">{rightSlot?.appBanner?.label}</span>
                <span className="sm:hidden">Get the App</span>
                
               <a   href={rightSlot?.appBanner?.playStoreLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center hover:opacity-80 transition-opacity"
                  aria-label="Download on Google Play"
                >
                  <img src="/Home/playstore.svg" alt="Google Play" className="h-5 w-5" />
                </a>
                
              <a    href={rightSlot?.appBanner?.appStoreLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center hover:opacity-80 transition-opacity"
                  aria-label="Download on App Store"
                >
                  <img src="/Home/applestore.svg" alt="App Store" className="h-5 w-5" />
                </a>
              </>
            ) : (
              socialLinks.map((link) => {
                const icon = iconForLink(link);
                return (
                  
                 <a   key={link.id}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={link.label}
                    className="flex items-center hover:-translate-y-1 transition-all duration-300 ease-out rounded-full p-[5px] bg-white"
                  >
                    {icon ? <img src={icon} alt={link.label} className="h-4 w-4" /> : <span className="text-xs">{link.label}</span>}
                  </a>
                );
              })
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default TopBar;